import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AssessmentRowComponent } from '../assessment-row/assessment-row.component';
import { EmrInputComponent } from "../../../../shared/emr-input/emr-input.component";
import { EmrCheckboxComponent } from "../../../../shared/emr-checkbox/emr-checkbox.component";
import { HEENTFormGroup } from 'src/app/calvin-emr-shared/models/assessments/HEENT.model';
import { FormOption } from 'src/app/shared/models/form-option.model';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { WnlGroupDirective } from '../wnl/wnl-group.directive';
import { WnlControlDirective } from '../wnl/wnl-control.directive';

@Component({
  selector: 'app-heent-form',
  templateUrl: './heent-form.component.html',
  styleUrls: ['./heent-form.component.scss', '../assessments-tab.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    AssessmentRowComponent,
    EmrInputComponent,
    EmrCheckboxComponent,
    WnlGroupDirective,
    WnlControlDirective,
  ],
})
export class HeentFormComponent {

  formGroup = input.required<HEENTFormGroup>();
  patient = input.required<Patient>();

  get abnormalFontanelles(): boolean {
    return !!this.formGroup().controls.abnormalFontanelles.value;
  }

  get suturesOverriding(): boolean {
    return !!this.formGroup().controls.suturesOverriding.value;
  }

  reset() {
    this.formGroup().enable({ emitEvent: false });
  }

  pupillaryResponseOptions = [
    new FormOption('Sluggish'),
    new FormOption('Absent'),
    new FormOption('WNL'),
  ];

  pupillaryDilationOptions = [
    new FormOption('2mm'),
    new FormOption('4mm'),
    new FormOption('6mm'),
    new FormOption('8mm'),
  ];
}